/**
 * フッターの西暦自動更新モジュール
 *
 * - .js-year クラスを持つ要素すべてに現在の西暦を自動挿入
 * - コピーライト表記などの自動更新に便利
 *
 * @example
 *   const footerYear = new FooterYear();
 *   footerYear.init();
 */
export class FooterYear {
    /**
     * .js-year要素すべてに現在の西暦を挿入
     */
	init() {
		const year = new Date().getFullYear();
		document
			.querySelectorAll('.js-year')
			.forEach((el) => (el.textContent = year));
	}
}
